import React from 'react';
import DefaultLayout from '../../../layouts/default';

// Import local equipment compliance components
import ComplianceOverview from './components/ComplianceOverview';
import EquipmentDashboardTables from './components/EquipmentDashboardTables';
import MaintenanceLogisticsDashboard from './components/MaintenanceLogisticsDashboard';
import MaintenanceAuditDashboard from './components/MaintenanceAuditDashboard';

function EquipmentComplianceCenter() {
  return (
    <DefaultLayout>
      <div className="flex flex-col gap-6 bg-slate-50 min-h-screen">
        {/* Metric Summary Ribbon Cards */}
        <ComplianceOverview />

        {/* Aggregated Categorical and Maintenance Grid Summaries */}
        <EquipmentDashboardTables />

        {/* Logistic Schedules, Tracking Logs, and Location Layouts */}
        <MaintenanceLogisticsDashboard />

        {/* Recent Updates, Completed Action Histories, and Audit Logs */}
        <MaintenanceAuditDashboard />
      </div>
    </DefaultLayout>
  );
}

export default EquipmentComplianceCenter;
